import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=68e239ec&scoped=true"
import script from "./StatCard.vue?vue&type=script&lang=ts"
export * from "./StatCard.vue?vue&type=script&lang=ts"
import style0 from "./StatCard.vue?vue&type=style&index=0&id=68e239ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e239ec",
  null
  
)

export default component.exports